import { Dimensions } from 'react-native';
import { IconButton } from 'react-native-paper';
import { EdgeInsets } from 'react-native-safe-area-context';
import styled from 'styled-components/native';

const maxHeight = Dimensions.get('screen').height;

export const Container = styled.View<{ insets: EdgeInsets }>`
  flex: 1;
  justify-content: center;
  align-items: stretch;
  padding-top: ${({ insets }) => insets.top ?? 10}px;
  padding-bottom: ${({ insets }) => insets.bottom ?? 10}px;
  max-height: ${maxHeight}px;
`;

export const Head = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const CloseIcon = styled(IconButton).attrs(({ theme }) => ({
  color: theme.colors.primary,
}))``;

export const Spacer = styled.View`
  width: 50px;
  height: 50px;
`;
